/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
// import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";
import ProductPage from "layouts/pages/landing-pages/product";
import Catalog from "layouts/pages/landing-pages/catalog";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes
      .map((route) => {
        if (route.collapse) {
          return getRoutes(route.collapse);
        }
        // Solo crear rutas si existe la propiedad 'component'
        if (route.route && route.component) {
          return <Route exact path={route.route} element={route.component} key={route.key || route.route} />;
        }
        return null;
      })
      .filter(Boolean); // Elimina nulls de rutas anidadas

  function ProductRouteWrapper({ element }) {
    const { name, brand } = useParams();
    // Solo letras, números, guiones y guiones bajos
    const isValidName = /^[a-zA-Z0-9_-]+$/.test(name);
    const isValidBrand = /^[a-zA-Z0-9_-]+$/.test(brand);
    if (!isValidName || !isValidBrand) return <Navigate to="/" />;
    return element;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        {/* <Route path="/presentation" element={<Presentation />} /> */}
        <Route path=":brand/:name" element={<ProductRouteWrapper element={<ProductPage />} />} />
        <Route path=":brand" element={<Catalog />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}
